import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { deepCopy } from '../../../../../../common/services/common.service';
import { categories } from '../../../../../../redux/categories/action';
import { selectCategoriesListItems } from '../../../../../../redux/categories/selector';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { tags } from '../../../../../../redux/tags/action';
import { selectTagsListItems } from '../../../../../../redux/tags/selector';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';
import { customers } from '../../../../../../redux/customers/action';
import { vendors } from '../../../../../../redux/vendors/action';
import { selectVendorsListItems } from '../../../../../../redux/vendors/selector';
import ServiceabilityComponent from '../components/serviceability.component';
import { selectServiceabilityQueryItems } from '../../../../../../redux/serviceabilities/selector';
import { selectPinCodesListItems } from '../../../../../../redux/pin-codes/selector';
import { serviceabilities } from '../../../../../../redux/serviceabilities/action';
import { pinCodes } from '../../../../../../redux/pin-codes/action';
import { productTypes } from '../../../../../../redux/product-types/action';
import { selectProductTypesListItems } from '../../../../../../redux/product-types/selector';
import { variants } from '../../../../../../redux/variants/action';
import { selectVariantsListItems } from '../../../../../../redux/variants/selector';
import { products } from '../../../../../../redux/products/action';
import { selectProductsListItems } from '../../../../../../redux/products/selector';
import { subCategories } from '../../../../../../redux/sub-categories/action';
import { selectSubCategoriesListItems } from '../../../../../../redux/sub-categories/selector';


let currentChange: any = {}
const Serviceability = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const libraryData = useSelector(selectListItems)
  const tagsLists = useSelector(selectTagsListItems)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productTypesLists = useSelector(selectProductTypesListItems)
  const variantsLists = useSelector(selectVariantsListItems)
  const productsLists = useSelector(selectProductsListItems)
  const vendorsLists = useSelector(selectVendorsListItems)
  const customerLists = useSelector(selectCustomersListItems)
  const subCategoryListItems = useSelector(selectSubCategoriesListItems)
  const queryItems = useSelector(selectServiceabilityQueryItems)
  const pinCodesLists = useSelector(selectPinCodesListItems)
  const [selectedServiceabilityValues, setSelectedServiceabilityValues] = useState([]);
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedServiceabilitys,
    setSelectedServiceabilitys
  ] = useState<any>([])
  const [
    categoryImageIndex,
    setServiceabilityImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const fetchQueryById = () => {
    dispatch(serviceabilities.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy-manager/serviceabilities/query`, entity: 'serviceabilities', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedServiceabilitys({ ...selectedServiceabilitys, [field]: event })
  }
  const handleInnerFormChange: any = ({ value, field, data }: any) => {
    currentChange = { value, field, data, idx: 0 }
    const fields = R.split(
      '.',
      field
    );
    const valueData = { ...data, [fields[1]]: value }// inner data update
    setSelectedServiceabilitys({ ...selectedServiceabilitys, [fields[0]]: valueData });
  }
  const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(
    () => {
      dispatch(tags.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
        entity: 'tags',
        jsonData: {}

      })).then(() => {
        dispatch(categories.list({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
          entity: 'categories',
          jsonData: {}
        }))
      })
        .then(() => {
          dispatch(productTypes.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`, entity: 'productTypes', jsonData: {} }))
        })
        .then(() => {
          dispatch(variants.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/variants/list`, entity: 'variants', jsonData: {} }))
        })
        .then(() => {
          dispatch(products.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/list`, entity: 'products', jsonData: {} }))
        })
        .then(() => {
          dispatch(vendors.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/market-place/vendors/list`, entity: 'vendors', jsonData: {} }))
        }).then(() => {
          dispatch(customers.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/customers/list`,
            entity: 'customers',
            jsonData: {}
          }));
        }).then(() => {
          dispatch(pinCodes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/pin-codes/list`,
            entity: 'pincodes',
            jsonData: {}
          }))
        }).then(() => {
          if (parmas?.id > 0) {
            fetchQueryById()

          } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)
            const localSelectedDsiscounts = addNewServiceabilityValuesRow({ selectedServiceabilityValuesArg: selectedServiceabilityValues });
            setSelectedServiceabilityValues(localSelectedDsiscounts)
            setIsLoading(false)
          }
        })
    },
    []
  )


  const getSubCategories = async (data: any) => {
    await dispatch(subCategories.resetAction({ actionType: 'list' }))
    await dispatch(subCategories.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
      entity: 'categories',
      jsonData: {
        "Filters": [
          {
            "FieldName": "ParentCategoryId",
            "FilterOperatorId": 1,
            "FieldValue": data,
            "FieldType": "number"
          }
        ],
      }
    }))
  }
  useEffect(
    () => {

      if (isQuery) {
        setSelectedServiceabilitys(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
        const serviceItemsData: any = queryItems?.result?.items?.Serviceability.map((item: any) => {
          const itemData = {
            Id: item?.Id,
            EntityId: item?.EntityId,
            Name: item?.Name,
            EntityTypeId: item?.EntityTypeId,
            CategoryId: item?.CategoryId,
            ProductTypeName: item?.ProductTypeName,
            SubCategoryName: item?.SubCategoryName,
            ProductName: item?.ProductName,
            VariantName: item?.VariantName,
            unit: item?.Circle?.radius?.unit,
            value: item?.Circle?.radius?.value,
            IsDeliveryHubEnabled: item?.IsDeliveryHubEnabled,
            ShippingTypeId: item?.ShippingTypeId
          }
          return itemData
        })
        const localSelectedDsiscounts = addNewServiceabilityValuesRow({ selectedServiceabilityValuesArg: serviceItemsData });
        setSelectedServiceabilityValues(localSelectedDsiscounts)
        selectedServiceabilitys.PINCode = queryItems?.result?.items?.Serviceability[0]?.PINCode?.PinCode
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    selectedServiceabilityValues.splice(selectedServiceabilityValues.length - 1, 1);
    const serviceItemsData: any = selectedServiceabilityValues.map((item: any) => {

      let categoryiesName = _.find(categoriesLists?.result?.items, ['Id', item?.CategoryId]);
      const itemData = {
        Id: item.Id,
        EntityTypeId: item?.EntityTypeId,
        EntityId: selectedServiceabilitys?.ServiceabilityTypeId,
        ShippingTypeId: item?.ShippingTypeId,
        IsDeliveryHubEnabled: item?.IsDeliveryHubEnabled,
        Name: item?.Name,
        CategoryId: item?.CategoryId,
        CategoryName: categoryiesName?.Name,
        SubCategoryName: item?.SubCategoryName,
        ProductTypeName: item?.ProductTypeName,
        ProductName: item?.ProductName,
        VariantName: item?.VariantName,
        PINCode: { PinCode: selectedServiceabilitys.PINCode },
        Circle: {
          gps: 'string',
          radius: {
            unit: item?.unit,
            value: item?.value
          }
        }

      }
      return itemData
    })
    const serviceabilityData = {
      "Id": selectedServiceabilitys?.Id,
      "IsActive": selectedServiceabilitys?.IsActive,
      "Name": selectedServiceabilitys?.Name,
      "ServiceabilityTypeId": selectedServiceabilitys?.ServiceabilityTypeId,
      "Description": selectedServiceabilitys?.Description,
      "IsAlwaysEnabled": selectedServiceabilitys?.IsAlwaysEnabled,
      "StartDateUtc": selectedServiceabilitys?.StartDateUtc,
      "EndDateUtc": selectedServiceabilitys?.EndDateUtc,
      "Remarks": selectedServiceabilitys?.Remarks,
      "Inclusions": selectedServiceabilitys?.Inclusions,
      "Exclusions": selectedServiceabilitys?.Exclusions,
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": [

        ]
      },
      "Serviceability": serviceItemsData
    }
    if (parmas?.id > 0) {
      dispatch(serviceabilities.update({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy-manager/serviceabilities`, entity: 'serviceabilities', jsonData: {

          Records: [
            serviceabilityData

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      dispatch(serviceabilities.create({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy-manager/serviceabilities`, entity: 'serviceabilities', jsonData: {

          Records: [
            serviceabilityData
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/policy-manager/serviceabilities')
  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 163,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setServiceabilityImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'serviceabilities',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const addNewServiceabilityValuesRow = ({ selectedServiceabilityValuesArg }: any) => {
    const localSelectedServiceabilityValues = deepCopy(selectedServiceabilityValuesArg);
    const newServiceabilityValue = {
      Id: 0,
      ShippingTypeId: 0,
      EntityId: selectedServiceabilitys?.ServiceabilityTypeId,
      EntityTypeId: 163,
      ShippingTypePreferenceId: 0,
      Name: '',
      PinCode: selectedServiceabilitys?.PinCode,
      CategoryId: 0,
      ProductName: '',
      ProductTypeName: '',
      VariantName: '',
      Circle: {
        radius: {}
      }
    };
    if (
      localSelectedServiceabilityValues.length === 0 ||
      localSelectedServiceabilityValues[localSelectedServiceabilityValues?.length - 1]
        ?.Name !== ''
    ) {
      localSelectedServiceabilityValues?.push(newServiceabilityValue);
    }

    return localSelectedServiceabilityValues;
  };
  const handleFormServiceabilityItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedServiceabilityValues); // deep copy of items
    let item = items[idx]; // deep copy of item to be edited
    item = { ...item, [field]: value }; // updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx };
    setSelectedServiceabilityValues(items);
  };
  const setServiceabilityValuesInfo = async () => {
    let localServiceabilityValues = deepCopy(selectedServiceabilityValues);
    localServiceabilityValues.splice(currentChange.idx, 1, {
      ...localServiceabilityValues[currentChange.idx],
    });
    localServiceabilityValues = addNewServiceabilityValuesRow({
      selectedServiceabilityValuesArg: localServiceabilityValues,
    });
    currentChange.field = 'NameDONE';
    setSelectedServiceabilityValues(localServiceabilityValues);
  };
  useEffect(() => {
    if (currentChange.field === 'Name') {
      setServiceabilityValuesInfo();
    }
  }, [selectedServiceabilityValues]);

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setMediaInfo()
      }
    },
    [mediaFiles]
  )


  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :


        <ServiceabilityComponent
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedServiceabilitys={selectedServiceabilitys}
          shippingType={libraryData?.result?.ServiceabilityConstruct}
          fileTypes={libraryData?.result?.FileType}
          categories={categoriesLists?.result?.items}
          vendors={vendorsLists?.result?.items}
          allTags={tagsLists?.result?.items}
          back={back}
          onInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          handleFormMediaItemChange={handleFormMediaItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
          id={parmas?.id}
          variants={variantsLists?.result?.items}
          productTypes={productTypesLists?.result?.items}
          subCategories={subCategoryListItems?.result?.items}
          products={productsLists?.result?.items}
          pinCodes={pinCodesLists?.result?.items}
          customers={customerLists?.result?.items}
          getSubCategories={getSubCategories}
          selectedServiceabilityValues={selectedServiceabilityValues}
          handleFormServiceabilityItemChange={handleFormServiceabilityItemChange}
        />
      }

    </>
  )

}

export default Serviceability;